<div class="field-control">
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
    @for (m of memberships; track m) {
    <div class="relative border border-dc-navy px-6 py-6 text-dc-navy dc-card-stretch">
      <!-- Membership Details -->
      <div class="space-y-4 dc-card-stretch-body">
         <h3 class="text-2xl font-semibold text-dc-navy min-h-10">
            {{ lang == 'ar' ? m["DC Name Arabic"] : m["DC Name English"] }}
          </h3>
        <div class="mb-4 space-y-4">
          <div class="dc-card-field">
            <span class="dc-card-field-label">{{ "COO.MEM_NO" | translate }}</span>
            <span class="dc-card-field-value">{{ m["CSN"] }}</span>
          </div>

          <div class="dc-card-field">
            <span class="dc-card-field-label">
              {{ "COO.TRADE_LIC_NO" | translate }}
            </span>
            <span class="dc-card-field-value">
              {{ m["License Number"] }}
            </span>
          </div>
        </div>
        <div class="dc-card-stretch-actions">
          @if (membershipId === m.CSN) {
          <app-button
            [label]="'BUTTONS.SELECTED' | translate"
            [classesName]="'btn-primary-big btn-edge-cut-green mt-4'"
            (onBtnClick)="setSelectedMemberShip(m)"
          ></app-button>
          } @else {
          <app-button
            [label]="'BUTTONS.SELECT' | translate"
            [classesName]="'mt-4 btn-primary-big'"
            (onBtnClick)="setSelectedMemberShip(m)"
          ></app-button>
          }
        </div>
      </div>
      <!-- Bottom navy corner -->
      <div [ngClass]="membershipId === m.CSN ? 'dc-card-corner-green': 'dc-card-corner-blue'"></div>
    </div>
    }
  </div>
</div>
